"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { User, Award } from "lucide-react";
export default function GoverningCouncilMember(t0) {
  const $ = _c(35);
  const {
    member,
    isEven
  } = t0;
  const {
    id,
    name,
    designation,
    position,
    image,
    bio
  } = member;
  const hasImage = Boolean(image);
  const t1 = `member-${id}`;
  const t2 = `py-12 sm:py-16 md:py-20 border-b border-[#0F1C2E]/10 transition-colors duration-300 ${isEven ? "bg-[#F4EFE6]" : "bg-[#EAE4D8]/60"}`;
  const t3 = `lg:col-span-8 flex flex-col justify-start ${isEven ? "lg:order-2" : "lg:order-1"}`;
  let t4;
  if ($[0] !== name) {
    t4 = <h2 className="font-display text-[28px] sm:text-[36px] md:text-[42px] font-semibold leading-[1.15] text-[#0F1C2E] mb-2 tracking-tight">{name}</h2>;
    $[0] = name;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Award size={16} className="text-[#DF6D2A]" />;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== designation) {
    t6 = <div className="flex items-center gap-2">{t5}<span className="font-display text-[16px] sm:text-[18px] text-[#DF6D2A] font-medium tracking-wide">{designation}</span></div>;
    $[3] = designation;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== position) {
    t7 = position && <p className="font-body text-[13px] sm:text-[14px] text-[#4C596B]/80 font-medium italic mt-1">{position}</p>;
    $[5] = position;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t6 || $[8] !== t7) {
    t8 = <div className="flex flex-col gap-1.5">{t6}{t7}</div>;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t4 || $[11] !== t8) {
    t9 = <div className="mb-6 sm:mb-8">{t4}{t8}</div>;
    $[10] = t4;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== bio) {
    t10 = bio ? bio.split("\n\n").map(_temp) : null;
    $[13] = bio;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10) {
    t11 = <div className="flex flex-col gap-4 font-body text-[14px] sm:text-[15.5px] leading-[1.75] text-[#4C596B]">{t10}</div>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t3 || $[19] !== t9) {
    t12 = <div className={t3}>{t9}{t11}</div>;
    $[17] = t11;
    $[18] = t3;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const t13 = `lg:col-span-4 ${isEven ? "lg:order-1" : "lg:order-2"}`;
  let t14;
  if ($[21] !== hasImage || $[22] !== image || $[23] !== name) {
    t14 = <div className="relative w-full aspect-[3/4] max-w-[320px] mx-auto lg:max-w-none rounded-2xl bg-[#0F1C2E] overflow-hidden shadow-2xl border-4 border-white/50 group">{hasImage ? <><img src={image} alt={name} className="w-full h-full object-cover object-top grayscale-[15%] sepia-[5%] transition-transform duration-700 group-hover:scale-[1.03] group-hover:grayscale-0" loading="lazy" /><div className="absolute inset-0 bg-gradient-to-t from-[#0F1C2E]/60 via-transparent to-transparent opacity-80" /></> : <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-br from-[#0F1C2E] to-[#1A2B42]"><User size={64} className="text-[#C9A84C]/40 mb-4" /><span className="font-display text-[#F4EFE6]/60 tracking-wider uppercase text-sm">Portrait Unavailable</span></div>}</div>;
    $[21] = hasImage;
    $[22] = image;
    $[23] = name;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t13 || $[26] !== t14) {
    t15 = <div className={t13}>{t14}</div>;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t12 || $[29] !== t15) {
    t16 = <div className="max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8"><div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">{t12}{t15}</div></div>;
    $[28] = t12;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t1 || $[32] !== t16 || $[33] !== t2) {
    t17 = <section id={t1} className={t2}>{t16}</section>;
    $[31] = t1;
    $[32] = t16;
    $[33] = t2;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
}
function _temp(para, idx) {
  return <p key={idx} className="leading-relaxed text-justify sm:text-left">{para}</p>;
}